import React from 'react';
import { UPLOAD_SOURCES } from '@cld/upload-widget';
import { asAbsolute } from 'root/routes/utils';
import DropBoxTab from '../index';
import dbConsts from '../data/consts';
import ContextItems from '../components/ContextItems';

export default [
  {
    path: asAbsolute(UPLOAD_SOURCES.DROPBOX),
    component: DropBoxTab,
    routes: [
      {
        path: asAbsolute(UPLOAD_SOURCES.DROPBOX, 'recent'),
        render: (props) => <ContextItems context={dbConsts.CONTEXTS.RECENT} {...props} />,
      },
      {
        path: asAbsolute(UPLOAD_SOURCES.DROPBOX, 'search'),
        render: (props) => <ContextItems context={dbConsts.CONTEXTS.SEARCH} {...props} />,
      },
    ],
  },
];
